<template>
    <div class="view-reserva-error">
        <headerApp />
        <div class="container">
            <h2>Pago no completado</h2>
            <p v-if="msg">{{ msg }}</p>
            <p v-else>El pago no pudo completarse o quedó pendiente. Podés reintentar desde Reservas.</p>
            <button class="btn btn-primary" @click="goReservas">Ver reservas</button>
            <button class="btn btn-link" @click="goHome">Volver al inicio</button>
        </div>
    </div>
</template>

<script>
export default {
    name: 'ReservaError',
    computed: {
        msg () {
            // Optional data passed via deep link query params.
            if (this.$route && this.$route.query) {
                const result = this.$route.query.result;
                const status = this.$route.query.status || this.$route.query.collection_status;
                if (result || status) {
                    return `Resultado: ${result || 'desconocido'}${status ? ' (' + status + ')' : ''}`;
                }
            }
            return null;
        }
    },
    methods: {
        goReservas () {
            this.$router.push({ name: 'reservas' });
        },
        goHome () {
            this.$router.push({ name: 'home' });
        }
    }
};
</script>

<style scoped>
.container {
    padding: 1rem;
}
.btn {
    margin-right: 0.5rem;
}
</style>




// WEBPACK FOOTER //
// src/components/views/ReservaError.vue